import { broadcastsApi } from "@circle-react/api/broadcastsApi";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import type { ApiError } from "@/react/config/CustomErrors";

interface Response {
  broadcast: {
    id: number;
  };
}

/**
 * Broadcasts being created from other sources
 */
export const useCreateFromSource = () => {
  const toastr = useToast();

  return useMutation<
    Response,
    ApiError,
    Parameters<typeof broadcastsApi.createFromSource>[0]
  >({
    mutationFn: broadcastsApi.createFromSource,
    onError: (error: ApiError) => {
      if (typeof error?.errorDetails === "string") {
        return toastr.error(error.errorDetails);
      }

      return toastr.error(t("something_went_wrong"));
    },
  });
};
